import { useState, useRef, useEffect } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import { MdClose, MdEdit } from "react-icons/md";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FormControl } from "@mui/material";
import { Autocomplete } from "@react-google-maps/api";
import { useMutation } from "react-query";
import axios from "axios";

import Config, {
  landlord_property_type,
  listing_type,
  bhk_options,
  propertyFeatures,
} from "../../Config";

import SelectOptionModal from "../../Components/SelectOptionModal";
import {
  CardWrapper,
  CombineInputGroup,
  FieldWrapper,
  FieldWrappers,
  InputGroup,
  SelectionCard,
} from "../../Components/Styles/InputStyles";
import { furnishedOptions, preferredTenantOptions } from "../../helpers";
import { FaPhone, FaSpinner, FaWhatsapp } from "react-icons/fa";
import Images from "../../Images";
import SelectFeaturesModal from "../../Components/SelectFeaturesModal";
import { useParams } from "react-router-dom";
import DropZone from "../../Components/InventoryForm/Dropzone";

const InventoryForm = () => {
  const { id: ownerId } = useParams();
  const [showFeaturesModal, setShowFeaturesModal] = useState(false);
  const [isBhkModalOpen, setIsBhkModalOpen] = useState(false);
  const [apiData, setApiData] = useState(null);

  const autocompleteRef = useRef(null);

  const handlePlaceSelect = (setFieldValue) => {
    const place = autocompleteRef.current.getPlace();
    if (place?.formatted_address) {
      setFieldValue("address", place.formatted_address);
    }
  };

  // const validationSchema = Yup.object({});
  const validationSchema = Yup.object({
    inventoryName: Yup.string().required("Required"),
    listingType: Yup.string().required("Required"),
    inventoryType: Yup.string().required("Required"),
    inventorySubType: Yup.mixed().when("inventoryType", {
      is: (val) =>
        [
          Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
          Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
        ].includes(Number(val)),
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // buildingName: Yup.string().required("Required"),
    // flatNo: Yup.string().required("Required"),
    address: Yup.string().required("Required"),
    // carpetArea: Yup.number().typeError("Must be a number").required("Required"),
    // buildUpArea: Yup.number().required("Required"),
    amount: Yup.number().required("Required"),
    deposit: Yup.string().required("Required"),
    maintenance: Yup.string().required("Required"),
    furnishingType: Yup.string().required("Please select furnished type"),
    tenantPreference: Yup.string().required(
      "Please select preferred tenant type",
    ),
    foodPreference: Yup.string().required("Please select food preference"),
    features: Yup.array().min(1, "Select at least one feature"),
  });
  const initialValues = {
    inventoryName: "",
    listingType: "",
    inventoryType: "",
    inventorySubType: "",
    buildingName: "",
    flatNo: "",
    address: "",
    carpetArea: "",
    buildUpArea: "",

    amount: "",
    deposit: "",
    maintenance: "",
    furnishingType: "",
    tenantPreference: "",
    foodPreference: "",
    features: "",
    files: [],
  };

  const fetchFunction = async () => {
    const response = await axios.get(`${Config.apiUrl}/owner/form/${ownerId}`, {
      headers: {},
    });
    return response.data;
  };

  const getSuccess = (res) => {
    setApiData(res?.data);
    console.log("ownerId:", ownerId);
  };

  const {
    isLoading: isFetchingOwner,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
  });

  useEffect(() => {
    getListMutate();
  }, []);

  //-------------------Create Inventory-----------------------

  // const createInventory = async (formData ) => {
  //   return axios.post(`${Config.apiUrl}/owner/form/${ownerId}`, formData );
  // };
const createInventory = async ({ formData }) => {
  return axios.post(
    `${Config.apiUrl}/owner/form/${ownerId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
  // const { mutate, isLoading: isCreating } = useMutation(createInventory, {
  //   onSuccess: () => toast.success("Created Successfully"),
  //   onError: (err) => {
  //     console.log(err);
  //     toast.error("Error creating inventory");
  //   },
  // });
  const { mutate, isLoading: isCreating } = useMutation(createInventory, {
    onSuccess: (response, variables) => {
      toast.success(response?.data?.msg);

      variables.resetForm();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.msg || "Something went wrong");
    },
  });

  // const getInputClass = (isDisabled) => {
  //   return isDisabled
  //     ? "bg-gray-100 cursor-not-allowed"
  //     : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12 pr-6";
  // };

  const foodPreferenceOptions = [
    { value: 1, label: "Veg" },
    { value: 2, label: "Non-Veg" },
    { value: 3, label: "Whatever" },
  ];

  return (
    <MainWrapper>
      <Header>
        <HeaderContainer>
          <div className="flex items-center gap-3">
            <Logo src={Images.Logo} alt="Kipinn Logo" />
          </div>

          <HeaderActions>
            <button
              onClick={() => {
                const phone = apiData?.shareByMobile;
                if (!phone) return;
                window.open(`https://wa.me/${phone}`, "_blank");
              }}
              className="
                  flex items-center gap-2 
                  bg-green-500 hover:bg-green-600 
                  text-white 
                  px-4 py-2 rounded-xl 
                  text-sm font-semibold 
                  shadow-sm hover:shadow-md
                  transition-all duration-200
                "
            >
              <FaWhatsapp className="w-4 h-4" />
              <span className="hidden sm:inline">WhatsApp</span>
            </button>

            {/* Call */}
            <button
              onClick={() => {
                const phone = apiData?.shareByMobile;
                if (!phone) return;
                window.location.href = `tel:${phone}`;
              }}
              className="
                  flex items-center gap-2 
                  bg-primary-color hover:bg-teal-600 
                  text-white 
                  px-4 py-2 rounded-xl 
                  text-sm font-semibold 
                  shadow-sm hover:shadow-md
                  transition-all duration-200
                  "
            >
              <FaPhone className="w-4 h-4" />
              <span className="hidden sm:inline">Call</span>
            </button>
          </HeaderActions>
        </HeaderContainer>
      </Header>
      <Card>
        <OwnerCard>
          <UserImage src={Images.Avatar} />

          <div className="flex flex-col leading-tight">
            <span className="text-sm font-semibold text-gray-900">
              {apiData?.name || "Anurag Singh"}
            </span>
            <span className="text-[11px] text-gray-500">
              {apiData?.mobile || "+91 99778 37888"}
            </span>
          </div>
        </OwnerCard>

        <Title>
          List Your Inventory
          <span className="block text-sm text-gray-400 font-normal">
            Create your inventory listing
          </span>
          <span className="block w-20 h-[2px] bg-gradient-to-r from-primary-color to-teal-400 mx-auto mt-3 rounded-full"></span>
        </Title>

        {/* <TopSection>
          <OwnerCard>
            <UserImage src={Images.Avatar} />
            <div className="flex flex-col leading-tight">
              <span className="text-sm font-semibold text-gray-900">
                {apiData?.name || "Anurag Singh"}
              </span>
              <span className="text-[11px] text-gray-500">
                {apiData?.mobile || "+91 99778 37888"}
              </span>
            </div>
          </OwnerCard>

          <TitleWrap>
            <Title>
              List Your Inventory
            </Title>
            <Subtitle>
              Create your inventory listing
            </Subtitle>
          </TitleWrap>
        </TopSection> */}

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          // onSubmit={(values) => mutate(values)}
          onSubmit={(values, { resetForm }) => {
            const formData = new FormData();

            Object.keys(values).forEach((key) => {
              if (key !== "files") {
                formData.append(key, values[key]);
              }
            });

            formData.append("title", "Inventory Image");

            values.files.forEach((file) => {
              formData.append("files", file);
            });

            mutate({
              formData,
              resetForm,
            });
            // mutate({
            //   ...values,
            //   title: "Inventory Image",
            //   resetForm,
            // });
          }}
        >
          {({ values, setFieldValue, errors, touched, handleBlur }) => {
            const getSelectedLabels = () => {
              if (!values.features?.length) {
                return "Select Preference";
              }

              const selected = propertyFeatures.filter((feature) =>
                values.features.includes(feature.value),
              );

              return selected.map((f) => f.label).join(", ");
            };
            const handleFeaturesSelect = (selectedValues) => {
              setFieldValue("features", selectedValues);
            };
            const isBhkEditable = [
              Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
              Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
            ].includes(Number(values.inventoryType));

            const getUnitLabel = () => {
              const inventoryType = Number(values.inventoryType);

              if (
                inventoryType === Config.LANDLORD_PROPERTY_TYPE.SHOP_SHOWROOM ||
                inventoryType === Config.LANDLORD_PROPERTY_TYPE.OFFICE
              ) {
                return "Shop/Office No";
              }

              return "Flat/House No";
            };

            const isBhkRequired = [
              Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
              Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
            ].includes(Number(values.inventoryType));

            return (
              <Form className="flex flex-col gap-4">
                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="inventoryName">Listing Name *</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.inventoryName && errors.inventoryName
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type="text"
                        name="inventoryName"
                        id="inventoryName"
                        autoComplete="off"
                        placeholder="Listing name"
                      />
                    </FieldWrappers>
                    {/* {touched.inventoryName && errors.inventoryName && (
                      <p className="text-rose-600 text-sm mt-1">
                        {errors.inventoryName}
                      </p>
                    )} */}
                  </InputGroup>
                  <InputGroup>
                    <Label>Listing Type *</Label>
                    <FormControl fullWidth>
                      <Select
                        error={
                          touched.listingType && Boolean(errors.listingType)
                        }
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e5e7eb",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#9ca3af",
                          },
                          "&.Mui-error fieldset": {
                            borderColor: "#ef4444",
                          },
                        }}
                        className="px-2"
                        id="listingType"
                        name="listingType"
                        value={values.listingType}
                        onChange={(e) =>
                          setFieldValue("listingType", e.target.value)
                        }
                        onBlur={handleBlur}
                        style={{ height: "46px" }}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span className="text-gray-400">
                                Select listing type
                              </span>
                            );
                          }
                          const option = listing_type.find(
                            (opt) => opt.value === selected,
                          );
                          return option ? option.label : selected;
                        }}
                      >
                        <MenuItem value="" disabled>
                          <span className="text-gray-400">Listing Type</span>
                        </MenuItem>
                        {listing_type.map((option) => (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            disabled={option.label === "Sale"}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </InputGroup>
                </CombineInputGroup>
                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="inventoryType">Inventory Type *</Label>
                    <FormControl className="">
                      <Select
                        error={
                          touched.inventoryType && Boolean(errors.inventoryType)
                        }
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e5e7eb",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#9ca3af",
                          },
                          "&.Mui-error fieldset": {
                            borderColor: "#ef4444",
                          },
                        }}
                        className="px-2"
                        id="inventoryType"
                        name="inventoryType"
                        value={values.inventoryType}
                        onChange={(e) => {
                          const value = Number(e.target.value);
                          setFieldValue("inventoryType", value);

                          if (
                            ![
                              Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
                              Config.LANDLORD_PROPERTY_TYPE
                                .VILLA_INDEPENDENT_FLOOR,
                            ].includes(value)
                          ) {
                            setFieldValue("inventorySubType", "");
                          }
                        }}
                        onBlur={handleBlur}
                        style={{ height: "46px" }}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <span className="text-gray-400">
                                Select inventory type
                              </span>
                            );
                          }
                          const option = landlord_property_type.find(
                            (opt) => opt.value === selected,
                          );
                          return option ? option.label : selected;
                        }}
                      >
                        <MenuItem value="" disabled>
                          <span className="text-gray-400">Inventory Type</span>
                        </MenuItem>
                        {landlord_property_type.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="bhk">Bhk *</Label>

                    <FieldWrappers
                      onClick={() => {
                        if (isBhkEditable) {
                          setIsBhkModalOpen(true);
                        }
                      }}
                      // className={`border border-gray-200 ${
                      //   !isBhkEditable
                      //     ? "bg-gray-100 cursor-not-allowed opacity-70"
                      //     : "cursor-pointer"
                      // }`}
                      className={`border ${
                        isBhkRequired &&
                        touched.inventorySubType &&
                        errors.inventorySubType
                          ? "border-red-500"
                          : "border-gray-200"
                      } ${
                        !isBhkEditable
                          ? "bg-gray-100 cursor-not-allowed opacity-70"
                          : "cursor-pointer"
                      }`}
                    >
                      <Field
                        type="text"
                        name="bhk"
                        id="bhk"
                        autoComplete="off"
                        // readOnly
                        // value={getLocationLabel()}
                        readOnly
                        value={
                          bhk_options.find(
                            (opt) => opt.value === values.inventorySubType,
                          )?.label || "Select BHK"
                        }
                        className="w-full border-none outline-none bg-transparent cursor-pointer"
                      />
                      <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                    </FieldWrappers>
                    {/* 
                    {touched.inventorySubType && errors.inventorySubType && (
                      <p className="text-rose-600 text-sm mt-1">
                        {errors.inventorySubType}
                      </p>
                    )} */}
                  </InputGroup>
                </CombineInputGroup>
                <AddressInput>
                  <InputGroup>
                    <Label htmlFor="address">Address *</Label>

                    <FieldWrappers
                      className={`w-full pl-0 border ${
                        touched.address && errors.address
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Autocomplete
                        className="w-full"
                        onLoad={(autocomplete) =>
                          (autocompleteRef.current = autocomplete)
                        }
                        onPlaceChanged={() => handlePlaceSelect(setFieldValue)}
                        options={{
                          componentRestrictions: { country: "in" },
                          types: ["geocode"],
                        }}
                      >
                        <input
                          type="text"
                          value={values.address}
                          onChange={(e) => {
                            setFieldValue("address", e.target.value);
                          }}
                          placeholder="Enter address"
                          // className={getInputClass(false)}
                          className="w-full pr-6 bg-transparent border-none outline-none pl-2"
                        />
                      </Autocomplete>
                      {values.address && (
                        <button
                          type="button"
                          onClick={() => setFieldValue("address", "")}
                          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700"
                        >
                          <MdClose />
                        </button>
                      )}
                    </FieldWrappers>

                    {/* {touched.address && errors.address && (
                      <p className="text-rose-600 text-sm mt-1">
                        {errors.address}
                      </p>
                    )} */}
                  </InputGroup>
                </AddressInput>
                <CombineInputGroup>
                  <InputGroup>
                    <Label>Building/Tower/Block</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.buildingName && errors.buildingName
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type="text"
                        id="buildingName"
                        name="buildingName"
                        placeholder="Enter building name"
                        autoComplete="off"
                      />
                    </FieldWrappers>
                  </InputGroup>

                  <InputGroup>
                    <Label>{getUnitLabel()}</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.flatNo && errors.flatNo
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        name="flatNo"
                        placeholder={`Enter ${getUnitLabel().toLowerCase()}`}
                        autoComplete="off"
                      />
                    </FieldWrappers>
                  </InputGroup>
                </CombineInputGroup>

                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="carpetArea">Carpet Area (sqft)</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.carpetArea && errors.carpetArea
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type=""
                        name="carpetArea"
                        id="carpetArea"
                        // className={getInputClass()}
                        placeholder="Enter carpet area"
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                        autoComplete="off"
                      />
                    </FieldWrappers>
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="buildUpArea">Built-up Area (sqft)</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.buildUpArea && errors.buildUpArea
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type=""
                        name="buildUpArea"
                        id="buildUpArea"
                        placeholder="Enter build-up area"
                        // className={getInputClass()}
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                        autoComplete="off"
                      />
                    </FieldWrappers>
                  </InputGroup>
                </CombineInputGroup>
                <InputGroup>
                  <Label htmlFor="amount">Monthly Rent (₹) *</Label>
                  <FieldWrappers
                    className={`border ${
                      touched.amount && errors.amount
                        ? "border-red-500"
                        : "border-gray-200"
                    }`}
                  >
                    <Field
                      type=""
                      name="amount"
                      id="amount"
                      autoComplete="off"
                      placeholder="Enter monthly amount"
                      min="1000"
                      max="5000000"
                      className=""
                      onKeyDown={(e) => {
                        if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </FieldWrappers>
                  {/* {touched.amount && errors.amount && (
                    <p className="text-rose-600 text-sm mt-1">{errors.amount}</p>
                  )} */}
                </InputGroup>

                <CombineInputGroup>
                  <InputGroup>
                    <Label htmlFor="deposit">Security Deposit (₹) *</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.deposit && errors.deposit
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type=""
                        name="deposit"
                        id="deposit"
                        autoComplete="off"
                        placeholder="Enter security deposit"
                        min="1"
                        max="1000000"
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FieldWrappers>
                    {/* {touched.deposit && errors.deposit && (
                      <p className="text-rose-600 text-sm mt-1">
                        {errors.deposit}
                      </p>
                    )} */}
                  </InputGroup>

                  <InputGroup>
                    <Label htmlFor="maintenance">Maintenance Charges (₹) *</Label>
                    <FieldWrappers
                      className={`border ${
                        touched.maintenance && errors.maintenance
                          ? "border-red-500"
                          : "border-gray-200"
                      }`}
                    >
                      <Field
                        type=""
                        name="maintenance"
                        id="maintenance"
                        autoComplete="off"
                        placeholder="Enter maintenance charges"
                        min="0"
                        onKeyDown={(e) => {
                          if (!/[0-9]/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </FieldWrappers>
                    {/* {touched.maintenance &&
                      errors.maintenance && (
                        <p className="text-rose-600 text-sm mt-1">
                          {errors.maintenance}
                        </p>
                      )} */}
                  </InputGroup>
                </CombineInputGroup>

                {/* Furnished Type */}
                <InputGroup>
                  <Label>Furnished Type *</Label>
                  <CardWrapper>
                    {furnishedOptions.map((option) => (
                      <SelectionCard
                        key={option.value}
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setFieldValue("furnishingType", option.value);
                        }}
                        className={
                          values.furnishingType === option.value
                            ? "bg-[#26A69A] text-white"
                            : "bg-gray-50 text-gray-800"
                        }
                      >
                        <span className="text-sm">{option.label}</span>
                      </SelectionCard>
                    ))}
                  </CardWrapper>
                  {touched.furnishingType && errors.furnishingType && (
                    <p className="text-rose-600 text-sm mt-1">
                      {errors.furnishingType}
                    </p>
                  )}
                </InputGroup>
                <InputGroup>
                  <Label>Preferred Tenant Type *</Label>
                  <CardWrapper>
                    {preferredTenantOptions.map((option) => (
                      <SelectionCard
                        key={option.value}
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setFieldValue("tenantPreference", option.value);
                        }}
                        className={
                          values.tenantPreference === option.value
                            ? "bg-[#26A69A] text-white"
                            : "bg-gray-50 text-gray-800"
                        }
                      >
                        <span className="text-sm">{option.label}</span>
                      </SelectionCard>
                    ))}
                  </CardWrapper>
                  {touched.tenantPreference && errors.tenantPreference && (
                    <p className="text-rose-600 text-sm mt-1">
                      {errors.tenantPreference}
                    </p>
                  )}
                </InputGroup>

                <InputGroup>
                  <Label>Food Preference *</Label>
                  <CardWrapper>
                    {foodPreferenceOptions.map((option) => (
                      <SelectionCard
                        key={option.value}
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setFieldValue("foodPreference", option.value);
                        }}
                        className={
                          values.foodPreference === option.value
                            ? "bg-[#26A69A] text-white"
                            : "bg-gray-50 text-gray-800"
                        }
                      >
                        <span className="text-sm">{option.label}</span>
                      </SelectionCard>
                    ))}
                  </CardWrapper>
                  {touched.foodPreference && errors.foodPreference && (
                    <p className="text-rose-600 text-sm mt-1">
                      {errors.foodPreference}
                    </p>
                  )}
                </InputGroup>

                <InputGroup>
                  <Label>Custom Features</Label>

                  <FieldWrappers
                    className={`border ${
                      touched.features && errors.features
                        ? "border-red-500"
                        : "border-gray-200"
                    }`}
                    onClick={() => setShowFeaturesModal(true)}
                    // className="border border-gray-400"
                  >
                    <Field
                      type="text"
                      readOnly
                      value={getSelectedLabels()}
                      className="w-full border-none outline-none bg-transparent cursor-pointer"
                    />

                    <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                  </FieldWrappers>

                  {/* {touched.features && errors.features && (
                    <p className="text-rose-600 text-sm mt-1">
                      {errors.features}
                    </p>
                  )} */}
                </InputGroup>

                <InputGroup>
                  <Label>Inventory Images</Label>

                  <Field name="files">
                    {({ field, form }) => (
                      <DropZone
                        setFieldValue={form.setFieldValue}
                        File={field.value}
                      />
                    )}
                  </Field>

                  {/* {touched.files && errors.files && (
                    <p className="text-rose-600 text-sm mt-1">
                      {errors.files}
                    </p>
                  )} */}
                </InputGroup>

                {/* Submit */}

                <SubmitWrapper>
                <SubmitBtn type="submit" disabled={isCreating}>
                  {isCreating ? (
                    <span className="flex items-center gap-2">
                      <FaSpinner className="animate-spin" />
                      Submitting...
                    </span>
                  ) : (
                    "Add Inventory"
                  )}
                </SubmitBtn>
              </SubmitWrapper>

                <SelectOptionModal
                  isOpen={isBhkModalOpen}
                  onClose={() => setIsBhkModalOpen(false)}
                  options={bhk_options}
                  selectedValue={values.inventorySubType}
                  onSelect={(val) => {
                    setFieldValue("inventorySubType", val);
                    setIsBhkModalOpen(false);
                  }}
                  width="1/3"
                />

                <SelectFeaturesModal
                  isOpen={showFeaturesModal}
                  onClose={() => setShowFeaturesModal(false)}
                  options={propertyFeatures}
                  selectedValue={values.features}
                  onSelect={handleFeaturesSelect}
                  title="Select Features"
                  searchPlaceholder="Search Features..."
                  width="1/3"
                />
              </Form>
            );
          }}
        </Formik>
      </Card>
      <Footer>© {new Date().getFullYear()} Kipinn. All rights reserved.</Footer>
    </MainWrapper>
  );
};

export default InventoryForm;

const MainWrapper = tw.div`
  min-h-screen bg-gray-50 flex flex-col
`;
const Header = tw.header`
  sticky top-0 z-50 
  bg-white/80 backdrop-blur-lg 
  border-b border-gray-100
`;
const HeaderContainer = tw.div`
  max-w-[1040px] mx-auto 
  w-full
  flex items-center justify-between
  py-3 px-5
`;
const Logo = tw.img`w-16 sm:w-20`;
const HeaderActions = tw.div`
  flex items-center gap-2 sm:gap-3
`;
const Card = tw.div`
  w-full max-w-5xl py-3 px-5 mx-auto mt-1
`;
const OwnerCard = tw.div`
  mx-auto mt-3 mb-2 
  flex items-center gap-2

  bg-white/80 backdrop-blur-md
  border border-gray-200
  
  rounded-full
  px-4 py-2      
  
  shadow-sm hover:shadow-md
  
  transition-all duration-300
  w-fit             
`;
const UserImage = tw.img`flex items-center justify-center w-8 h-8 rounded-full bg-primary-color text-white flex-shrink-0`;

const Title = tw.h2`
  text-xl font-bold 
  text-gray-900 
  tracking-tight 
  text-center 
  mb-5 
  relative
`;
const Label = tw.label`
  text-sm text-gray-600 font-medium
`;
const AddressInput = tw.div`grid md:col-span-2 col-span-1`;
const SubmitWrapper = tw.div`
  flex justify-center mt-6
`;
const SubmitBtn = tw.button`
  px-6 py-2 text-white rounded-xl hover:bg-[#009688] text-white rounded-md shadow-md bg-gradient-to-r from-primary-color to-teal-400 transition disabled:opacity-50
`;

const Footer = tw.div`border-t mt-8 pt-4 text-center text-xs text-gray-400 mb-5`;

// const TopSection = tw.div`
//   flex flex-col md:flex-row md:items-center md:justify-between
//   gap-4 mb-6 mt-3
//   bg-white/70 backdrop-blur-md
//   border border-gray-200
//   rounded-2xl
//   p-4 shadow-sm
// `;
// const TitleWrap = tw.div`
//   flex flex-col md:text-right
// `;

// const Title = tw.h2`
//   text-xl font-bold text-gray-900
// `;

// const Subtitle = tw.p`
//   text-xs text-gray-500
// `;
// const OwnerCard = tw.div`
//   flex items-center gap-3
//   bg-white
//   border border-gray-200
//   rounded-full
//   px-4 py-2
//   shadow-sm
//   text-center
//   w-fit
// `;

// const UserImage = tw.img`
//   w-9 h-9 rounded-full bg-primary-color
// `;
